export enum LOCAL_STORAGE_ITEMS {
	USER_SECRET = 'user_secret',
	ACCESS_TOKEN = 'access_token',
	USER = 'user',
}

export enum SESSION_STORAGE_ITEMS {
	UTM = 'utm',
}
